import { notifyFailure } from 'app/Notifications/actions';

import {
  queryByAssetId,
  queryByAssetIdFailed,
  queryByAssetIdFulfilled,
  queryByWorkfrontId,
  queryByWorkfrontIdFailed,
  queryByWorkfrontIdFulfilled
} from './duck';

/**
 * handle calling amp api for asset id
 * @param {object} params - function params
 * @param {string} params.id - asset id
 * @param {boolean} params.isEvergreen - whether to query for an evergreen asset
 * @returns {Function} thunk
 */
export const queryByAssetIdThunk = ({ id, isEvergreen }) => async (
  dispatch,
  getState,
  { api }
) => {
  try {
    dispatch(queryByAssetId());
    const payload = await api.amp.getAmpAssetIdResponse(id, isEvergreen);
    dispatch(queryByAssetIdFulfilled(payload));
  } catch (err) {
    dispatch(notifyFailure(`'${err}' while querying by asset id`));
    dispatch(queryByAssetIdFailed(err));
  }
};

/**
 * handle calling amp api for asset id
 * @param {object} params - function params
 * @param {string} params.id - asset id
 * @param {boolean} params.isEvergreen - whether to query for an evergreen asset
 * @returns {Function} thunk
 */
export const queryByWorkfrontIdThunk = ({ id }) => async (dispatch, getState, { api }) => {
  try {
    dispatch(queryByWorkfrontId());
    const payload = await api.amp.getAmpWorkFrontResponse(id);
    dispatch(queryByWorkfrontIdFulfilled(payload));
  } catch (err) {
    dispatch(notifyFailure(`'${err.toString()}' while querying by workfront id`));
    dispatch(queryByWorkfrontIdFailed(err));
  }
};
